// src/components/map/mapIcons.ts
// Shared Big Blue Leaflet icon primitives only.
// Feature-owned artwork (FishIQ, Saved Spots, tournaments, Crew, avatar markup)
// stays with the feature that owns its presentation.

// @ts-ignore - local editor type noise for leaflet; runtime import is valid in this project
import L from "leaflet";

export type BigBlueDivIconOptions = {
  html: string;
  className?: string;
  iconSize: [number, number];
  iconAnchor: [number, number];
  popupAnchor?: [number, number];
};

export const createBigBlueDivIcon = (options: BigBlueDivIconOptions) =>
  L.divIcon({
    html: options.html,
    className: options.className || "bg-transparent",
    iconSize: options.iconSize,
    iconAnchor: options.iconAnchor,
    popupAnchor: options.popupAnchor,
  });

export const createBigBlueMapPinIcon = (isDark: boolean) =>
  createBigBlueDivIcon({
    className: "roddo-map-action-pin bg-transparent",
    html: `<div style="position:relative;width:36px;height:44px;filter:drop-shadow(0 7px 10px rgba(2,8,23,.30));"><div style="position:absolute;left:6px;top:2px;width:26px;height:26px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${isDark ? "#67D8E8" : "#2F80ED"};border:3px solid #fff;box-sizing:border-box;"><span style="position:absolute;left:50%;top:50%;width:7px;height:7px;border-radius:999px;background:#fff;transform:translate(-50%,-50%) rotate(45deg);"></span></div></div>`,
    iconSize: [36, 44],
    iconAnchor: [18, 39],
  });
